import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/helpers/services/auth.service';
import { ToasterLoaderService } from 'src/app/helpers/services/toaster-loader.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss', '../reset-password/reset-password.component.scss'],
  standalone: true,
  imports: [IonicModule, ReactiveFormsModule, TranslateModule, CommonModule]
})
export class SetPasswordComponent  implements OnInit {

  setPasswordForm!: FormGroup;
  email: string = '';
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';
  isSubmitted: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private toasterLoader: ToasterLoaderService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.setPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirm_password: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.route.queryParams.subscribe((response:any) => {
      this.email = response.email;
      // console.log(this.email);
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onSubmit() {
    this.errorMessage = '';
    this.isSubmitted = true;

    const { password, confirm_password } = this.setPasswordForm.value;
    let email = this.email;

    if (!this.setPasswordForm.valid) {
      this.setPasswordForm.markAllAsTouched();
      return;
    }

    if (password === confirm_password) {
      this.isLoading = true;
      this.authService.setPassword({email, password}).subscribe((response:any) => {
        this.isSubmitted = false;
        this.isLoading = false;
        if (response.success) {
          this.toasterLoader.toastMessage(response.message, 'success');
          this.router.navigate(['auth/login']);
        } else {
          this.errorMessage = response.message;
        }
      })
    } else {
      this.isSubmitted = false;
      this.errorMessage = 'Passwords do not match, please try again';
    }
  }

  
  cancel() {
    this.router.navigate(['auth/login']);
  }
}
